import gql from 'graphql-tag'

export const EXPORT_EXCEL_REPORT_MANAGEMENT_VEHICLE = gql`
  query ExcelReportManagementVehicle($filter: ExcelReportManagementVehicleFilter!) {
    excelReportManagementVehicle(filter: $filter) {
      isSuccessful
      message
      excelReportManagementVehicle {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_MANAGEMENT_DRIVER = gql`
  query ExcelReportManagementDriver($filter: ExcelReportManagementDriverFilter) {
    excelReportManagementDriver(filter: $filter) {
      isSuccessful
      message
      excelReportManagementDriver {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_SUMMARY_DAY_VEHICLE = gql`
  query ExcelReportSummaryDayVehicle($filter: ExcelReportSummaryDayVehicleFilter!) {
    excelReportSummaryDayVehicle(filter: $filter) {
      isSuccessful
      message
      ExcelReportSummaryDayVehicle {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_SUMMARY_DAY_DRIVER = gql`
  query ExcelReportSummaryDayDriver($filter: ExcelReportSummaryDayFilter) {
    excelReportSummaryDayDriver(filter: $filter) {
      isSuccessful
      message
      ExcelReportSummaryDayDriver {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_HISTORY_VEHICLE = gql`
  query ExcelReportVehicleTrip($filter: ExcelReportVehicleTripFilter) {
    excelReportVehicleTrip(filter: $filter) {
      isSuccessful
      message
      excelReportVehicleTrips {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_DETAIL_HISTORY_VEHICLE = gql`
  query ExcelReportDetailVehicleTrip($filter: ExcelReportDetailVehicleTripFilter!) {
    excelReportDetailVehicleTrip(filter: $filter) {
      isSuccessful
      message
      excelReportDetailVehicleTrips {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_SUMMARY_STOPPED = gql`
  query ExcelReportSummaryStopped($filter: ExcelReportSummaryStoppedFilter!) {
    excelReportSummaryStopped(filter: $filter) {
      isSuccessful
      message
      excelReportSummaryStopped {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_GEOLOCATION = gql`
  query ExcelReportGeolocation($filter: ExcelReportGeolocationFilter!) {
    excelReportGeolocation(filter: $filter) {
      isSuccessful
      message
      excelReportGeolocation {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_SUMMARY_GEOLOCATION = gql`
  query ExcelReportSummaryGeolocation($filter: GetReportExcelSummaryGeolocationFilter!) {
    excelReportSummaryGeolocation(filter: $filter) {
      isSuccessful
      message
      excelReportSummaryGeolocation {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_ALERT = gql`
  query ExcelReportAlert($filter: ExcelReportAlertFilter) {
    excelReportAlert(filter: $filter) {
      isSuccessful
      message
      excelReportAlert {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_DOOR = gql`
  query ExcelReportDoor($filter: ExcelReportDoorFilter!) {
    excelReportDoor(filter: $filter) {
      isSuccessful
      message
      excelReportDoor {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_RAW_SENSOR = gql`
  query ExcelRawSensorInfos($filter: GetExcelRawSensorInfoFilter!) {
    excelRawSensorInfos(filter: $filter) {
      isSuccessful
      message
      excelRawSensorInfos {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_FUEL = gql`
  query ExcelReportFuel($filter: GetExcelReportFuelFilter!) {
    excelReportFuel(filter: $filter) {
      isSuccessful
      message
      excelReportFuel {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_TIME_WINDOW = gql`
  query ExcelReportTimeWindow($filter: ExcelReportTimeWindowFilter!) {
    excelReportTimeWindow(filter: $filter) {
      isSuccessful
      message
      ExcelReportTimeWindow {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_DRIVER_SCORES = gql`
  query ExcelReportDriverScores($filter: ExcelReportDriverScoresFilter) {
    excelReportDriverScores(filter: $filter) {
      isSuccessful
      message
      excelReportDriverScores {
        base64
        id
      }
    }
  }
`

export const EXPORT_EXCEL_REPORT_OFFLINE_VEHICLE = gql`
  query ExcelReportVehiclesOffline($filter: ExcelReportVehicleOfflineFilter) {
    excelReportVehiclesOffline(filter: $filter) {
      isSuccessful
      message
      excelReportVehicleOffline {
        base64
        id
      }
      status
    }
  }
`
